<!--  -->
<template>
  <div class="home">
    <myhead />
    <div class="left">
      <weather />
      <div class="border"></div>
      <equipment />
      <div class="border" style="margin-bottom:6%"></div>
      <environment />
    </div>
    <div class="right">
      <highway />
      <div class="border" style="margin-bottom:6%"></div>
      <cardetect />
      <div class="border" style="margin-bottom:4%"></div>
      <risk />
      <div class="border" style="margin-bottom:6%"></div>
      <myvideo />
    </div>
    <mymenu />
    <div class="back" v-show = "backshow==1" @click="backtc">退出</div>
  </div>
</template>

<script>
// @ is an alias to /src
import myhead from "@/components/head.vue";
import weather from "@/components/weather.vue";
import equipment from "@/components/equipment.vue";
import environment from "@/components/environment.vue";
import highway from "@/components/highway.vue";
import cardetect from "@/components/cardetect.vue";
import risk from "@/components/risk.vue";
import mymenu from "@/components/menu.vue";
import myvideo from "@/components/myvideo.vue";
import fxqyone from "@/components/fxqyone.vue";
import fxqytwo from "@/components/fxqytwo.vue";
export default {
  data() {
    return {
      tcshow: 1,
      tcshow2: 1,
      backshow: 0
    };
  },

  components: {
    myhead,
    weather,
    equipment,
    environment,
    highway,
    cardetect,
    risk,
    myvideo,
    mymenu,
    fxqyone,
    fxqytwo
  },

  computed: {},

  mounted() {
    window["backshow"] = val => {
      this.backshow = val;
      // this.navshow = true;
    };
  },

  methods: {
    close() {
      this.tcshow2 = 0;
    },
    backtc(){
      this.backshow = 0;
      document.getElementById("iframe").contentWindow.MMAPI.close();
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  height: 100%;
  width: 100%;
  .left {
    height: 90%;
    width: 330px;
    // background: red;
    position: absolute;
    left: 1%;
    top: 10%;
  }
  .right {
    height: 90%;
    width: 330px;
    // background: red;
    position: absolute;
    right: 1%;
    top: 10%;
  }
  .border {
    width: 100%;
    height: 10px;
    background: url(../assets/border.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 3%;
  }
  .back {
    font-size: 20px;
    color: #bcdeff;
    font-family: pmzd;
    position: absolute;
    cursor: pointer;
    right: 23.5%;
    top: 95px;
  }
}
</style>